import * as React from 'react';
import { ArticleHeading1, ArticleParagraph1 } from '@cian/ui-kit';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import successIcon from './assets/Success.svg';
import * as styles from './styles.css';
import { trackAddressForm, VIEWED_TIMEOUT } from '../tracking';

interface IAddNewCardProps extends React.PropsWithChildren {
  containerRef?: React.Ref<HTMLDivElement>;
}

export const AddNewCardLayout: React.FC<IAddNewCardProps> = ({ containerRef, children }) => {
  return (
    <ActionAfterViewObserver callbackDelay={VIEWED_TIMEOUT} callback={trackAddressForm}>
      <div className={styles['container']} ref={containerRef}>
        <div className={styles['content']}>
          <div className={styles['titles']}>
            <ArticleHeading1>Мой дом — аналитика вашей недвижимости</ArticleHeading1>

            <ArticleParagraph1>
              Добавляйте квартиры, дома и участки — расскажем всё, что нужно для выгодной продажи, сдачи и поиска нового
              жилья
            </ArticleParagraph1>
          </div>

          <div>{children}</div>
        </div>

        <div className={styles['annotation']}>
          <div className={styles['icon']}>
            <img src={successIcon} />
          </div>

          <ArticleParagraph1>Данные в безопасности — никому их не передаём и не спамим</ArticleParagraph1>
        </div>
      </div>
    </ActionAfterViewObserver>
  );
};
